<template>
    <div class="user-layout-wrapper" :class="device">
        <div class="container">
            <router-view/>
            <div class="footer">
                <div class="links"><a>帮助</a><a>隐私</a><a>条款</a></div>
                <div class="copyright">Copyright &copy; 2018 xxxx出品</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserLayout',
    computed: {
        device () {
            return ''
        }
    }
}
</script>

<style lang="less">
.user-layout-wrapper {
    height: 100%;
    .container {
        padding: 120px 0;
        .top {
            text-align: center;
            margin-bottom: 20px;
        }
    }
    .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        margin: 48px 0 24px;
        text-align: center;
        a {
            padding: 0 10px;
        }
    }
}
</style>
